<template>
    <l-marker :lat-lng="getCoordinates(coordinates)">
        <l-icon
            icon-url="/svg/map/markers/restArea.svg"
            :icon-size="iconSize"
            :icon-anchor="[15.375, 37.5]"
        ><img src="/svg/map/markers/restArea.svg" class="marker-icon"
        /></l-icon>
    </l-marker>
</template>
<script>
import {latLng} from "leaflet";
import {
    LMarker,
    LIcon,
} from "vue2-leaflet";
import {mapGetters} from "vuex";

export default {
    name: "RouteMarker",
    components: {
        LMarker,
        LIcon,
    },
    props: {
        coordinates: {
            default: () => [],
        },
        iconSize: {
            default: () => [30.75, 37.5],
        },
    },
    data() {
        return {
            modalId: null,
            showTooltip: false,
        };
    },
    mounted() {
    },
    methods: {
        getCoordinates(coordinates) {
            return latLng(coordinates);
        },
    },
    computed: {
        ...mapGetters([
            "markers",
            "filters",
            "modal",
            "restAreas",
            "gasStationTypes",
            "objects",
        ]),
        typeInRestAreas() {
            if (this.type) {
                if (
                    this.restAreas.find((restArea) => restArea === this.type) ||
                    this.type === "restAreas" ||
                    this.type === "searchResult" ||
                    this.gasStationTypes.find((gasStation) => gasStation === this.type)
                ) {
                    return true;
                }
            }
            return false;
        },
        typeGasStation() {
            if (this.type) {
                if (
                    this.gasStationTypes.find((gasStation) => gasStation === this.type)
                ) {
                    return true;
                }
            }
            return false;
        },
    },
};
</script>
